var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainLost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 14,
    viewBox: "0 0 34 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14L30.177 14C32.1227 14 33.5536 12.1765 33.091 10.2867L31.1326 2.28666C30.8039 0.944217 29.6007 3.84599e-07 28.2186 5.05425e-07L17 1.48619e-06L5.78138 2.46695e-06C4.3993 2.58778e-06 3.19606 0.944219 2.86742 2.28667L0.909023 10.2867C0.446388 12.1765 1.87733 14 3.82298 14L17 14Z",
    fill: "#393A4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainLost);
export default __webpack_public_path__ + "static/media/trainLost.d1065475.svg";
export { ForwardRef as ReactComponent };